<template>
  <div class="content">
    <banner :items="bannerItem"></banner>
    <div class="newsupdate">
      <div class="container content-offset-container">
        <div class="section-title mb-60 text-center head-box">
          <h2 class="head-title"><a href="#">{{$Lang.L(latestinfo.title)}}</a></h2>
          <p class="head-sub">{{$Lang.L(latestinfo.desc)}}</p>
        </div>
        <div class="row">
          <carouselm :items="newsItem" :configs="{isremark:false,pageSize:4}"></carouselm>
        </div>
      </div>
    </div>
    <div class="corpintro">
      <div class="container content-offset-container" style="display: flex">
        <div class="corpitem leftbg">
          <div class="companylogo">
            <img src="../assets/castbead/logo.png" />
            <div class="slogon">We Are Professional.</div>
          </div>
        </div>
        <div class="corpitem">
          <div style="width: 100%">
            <div class="head-title"><a href="#">{{$Lang.L(aboutinfo.title)}}</a></div>
            <div class="introcontent" v-html="$Lang.L(corpInfo)"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="products">
      <div class="container content-offset-container">
        <h2 class="head-title"><a href="#">{{$Lang.L(productinfo.title)}}</a></h2>
        <p class="head-sub">{{$Lang.L(productinfo.desc)}}</p>
        <div class="navbar"><infeedmenu :items="productNav" :nodes="productNavNodes"></infeedmenu></div>
        <!-- <div class="items">
          <carouselm :items="newsItem" :configs="productcarousel"></carouselm>
        </div> -->
      </div>
    </div>
    <!-- <carousle3d></carousle3d> -->
    <div class="advantage">
      <div
        class="container"
        style="color: white; padding-top: 30px; padding-bottom: 30px"
      >
        <div class="row content-offset-container">
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <div class="col-md-6 row">
              <div class="col-md-4 col-xs-4 hidden-sm hidden-xs">
                <img src="../assets/castbead/icon/icon1.png" />
              </div>
              <div class="col-md-8 col-xs-12 col-xs-offset-3 col-md-offset-0">
                <h2 style="color: #ffe200">OVER 10 YEARS</h2>
                <p>More than 12 years of <br />manufacturing experience</p>
              </div>
            </div>
            <div class="col-md-6 row">
              <div class="col-md-4 col-xs-4 hidden-sm hidden-xs">
                <img src="../assets/castbead/icon/icon2.png" />
              </div>
              <div class="col-md-8 col-xs-12 col-xs-offset-3 col-md-offset-0">
                <h2 style="color: #ffe200">QUALITY PASSED</h2>
                <p>TSCA, PAHS <br />RoHS & REACH</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row content-offset-container">
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <div class="col-md-6 row">
              <div class="col-md-4 col-xs-4 hidden-sm hidden-xs">
                <img src="../assets/castbead/icon/icon3.png" />
              </div>
              <div class="col-md-8 col-xs-12 col-xs-offset-3 col-md-offset-0">
                <h2 style="color: #ffe200">SERVICES</h2>
                <p>
                  Sales team & technical <br />support team to cover<br />worldwide
                  markets
                </p>
              </div>
            </div>
            <div class="col-md-6 row">
              <div class="col-md-4 col-xs-4 hidden-sm hidden-xs">
                <img src="../assets/castbead/icon/icon4.png" />
              </div>
              <div class="col-md-8 col-xs-12 col-xs-offset-3 col-md-offset-0">
                <h2 style="color: #ffe200">FLEXIBILITY</h2>
                <p>Tailor made to<br />customer's<br />specification</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-bottom:20px;">
      <div class="container content-offset-container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <div class="head-box">
              <h2 class="head-title">{{$Lang.L(contactinfo.title)}}</h2>
              <p class="head-sub">{{$Lang.L(contactinfo.desc)}}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div style="text-align: left;margin-bottom:10px;"><img src="../assets/castbead/logo.png" /></div>
            <p><i class="iconfont icon-dizhi"></i>{{$Lang.L(chinaAddress)}}</p>
            <p><i class="iconfont icon-dizhi"></i>{{$Lang.L(hkAddress)}}</p>
            <p><i class="iconfont icon-dianhua"></i> China Tel & Fax:0769-2626 0513</p>
            <p><i class="iconfont icon-dianhua"></i> HK Tel:852-3706 5567</p>
            <p><i class="iconfont icon-youjian"></i> lowell.chan@castbead.com</p>
          </div>
          <div class="col-md-6">
            <form name="sentMessage">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$Lang.L(contactform.name)"
                      id="name"
                      required=""
                      data-validation-required-message="Please enter your name."
                    />
                    <p class="help-block text-danger"></p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control"
                      :placeholder="$Lang.L(contactform.email)"
                      id="email"
                      required=""
                      data-validation-required-message="Please enter your email address."
                    />
                    <p class="help-block text-danger"></p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <textarea
                      class="form-control"
                      :placeholder="$Lang.L(contactform.message)"
                      id="message"
                      required=""
                      data-validation-required-message="Please enter a message."
                      style="height: 200px"
                    ></textarea>
                    <p class="help-block text-danger"></p>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="row">
                <div class="col-lg-12 text-center">
                  <div id="success"></div>
                  <button id="submitMsg" type="submit" class="btn">
                    {{$Lang.L(contactform.sendmsg)}}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <chart></chart>
  </div>
</template>
<script>
import common from "../webapi/common.js";
import banner from "../components/banner.vue";
import carousle3d from "../components/carousel3d.vue";
import carouselm from "../components/carouselMulti.vue";
import chart from "../components/echarts.vue";
import infeedmenu from "../components/infeedmenu.vue";
export default {
  components: { banner, carousle3d, carouselm, chart, infeedmenu },
  data() {
    return {
      bannerItem: [
        // { targetUrl: "", hrefUrl:  ""  },
      ],
      productcarousel:{
        isremark:false
      },
      productinfo:{
        title:{
          en:'Products',
          cn:'产品中心',
          hk:'產品中心'
        },
        desc:{
          en:'',
          cn:'',
          hk:''
        }
      },
      latestinfo:{
        title:{
          en:'Latest Info',
          cn:'最近更新',
          hk:'最近更新'
        },
        desc:{
          en:'',
          cn:'',
          hk:''
        }
      },
      aboutinfo:{
        title:{
          en:'About Castbead',
          cn:'关于Castbead',
          hk:'關於Castbead'
        },
        desc:{
          en:'',
          cn:'',
          hk:''
        }
      },
      contactinfo:{
        title:{
          en:'ContactUs',
          cn:'联系我们',
          hk:'聯係我們'
        },
        desc:{
          en:'',
          cn:'',
          hk:''
        }
      },
      contactform:{
        name:{
          en:'Your Name',
          cn:'你的称呼',
          hk:'' 
        },
        email:{
          en:'Email Address',
          cn:'邮件地址',
          hk:''
        },
        message:{
          en:'Your Message',
          cn:'你的留言',
          hk:''
        },
        sendmsg:{
          en:'Submit',
          cn:'提交',
          hk:''
        }
      },
      corpInfo:{
         en:'<p class="MsoNormal" style="background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"></p><p><span lang="EN-US" style="font-size: 12pt; font-family: 宋体;"><span style="font-family: &quot;Comic Sans MS&quot;;">&nbsp; &nbsp; Castbead Chemical Limited is a lubrication\ntechnology company specialized in the development of the lubrication\napplications and the market in the die-casting industries. We have our\nwell-experienced engineer team with over 20 years’ experience in the fields of metal\nworking, die-casting, anti-rust and cleaning in the industry.</span></span><span lang="EN-US" style="font-size: 12pt; font-family: 宋体;"><br></span></p><p><span lang="EN-US" style="font-size: 12pt; font-family: 宋体;"><span style="font-family: &quot;Comic Sans MS&quot;;">\nCastbead&nbsp; shot bead&nbsp; is an advanced solid lubrication technology which is designed for\nAluminum and Magnesium alloy die-casting applications. It replaces the\ntraditional sticky graphite lubricant which improves the manufacturing cost,\nstrengthens the shell life of plunger, increases the cleanliness of finish\nproduct as well as this is an environmental friendly product.<br></span></span><span lang="EN-US" style="font-size: 12pt; font-family: 宋体;"><span style="font-family: &quot;Comic Sans MS&quot;;">&nbsp; &nbsp; In cope with the rapid development of Die-Casting industries in China, the\nsolid lubricant has widely adopted and used in the industries. &nbsp;Castbead\nhas well managed and equipped with formulation and technology of the cast bead\nand continues to provide a betterment in quality.</span></span><span lang="EN-US" style="font-size: 12pt; font-family: 宋体;"><span style="font-family: &quot;Comic Sans MS&quot;;">&nbsp;<br></span></span><span lang="EN-US" style="font-size: 12pt; font-family: 宋体;"><span style="font-family: &quot;Comic Sans MS&quot;;">&nbsp; &nbsp; Die Casting technology covers different industries such as automobile and its\naccessory parts, cellphones, computer and electronic parts, motors\nmanufacturing etc. The potentiality of the product is enormous especially in\nthe region of Asia including China and hence the demand for the solid lubricant\nis great. In comparison with the relative products in Europe and US, our\nproducts are better in quality and more competitive in prices.</span></span><span lang="EN-US" style="font-size: 12pt; font-family: 宋体;"><br></span><span lang="EN-US" style="font-size: 12pt; font-family: 宋体;"><span style="font-family: &quot;Comic Sans MS&quot;;">&nbsp; &nbsp; We appreciate to work with the die-casting manufacturers to provide best\nsolution for their die-casting applications as well as lubricant distributors.\nFor interested parties, please contact us.</span></span></p><p></p><p></p>',
         cn:'<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Castbead 是一家专注于润滑化学技术的公司，其资深的技术人员拥有超过30年的润滑产品研发应用及市场销售经验，涵盖金属加工、压铸润滑，防锈清洗等领域。</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 压铸冲头固体润滑技术， 是针对铝镁合金冷室压铸机的冲头润滑而设，使用润滑颗粒代替传统石墨高粘性润滑油能减低冲頭及料管的磨損, 延長使用寿命。优質的润滑顆粒更能减小鋳件沙孔的產生,免除污染,铸件更清洁,大大降低生産成本。傳統油基柱塞润滑油/膏在使用中產生大量有害煙氣及油霧,除了使設備及週边肮脏,更危害操作人員健康,顆料能大大改善车间環境。</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 随着中国压铸工业飞速发展, 压铸冲头固体润滑技术, 已被广范使用; 而其核心的润滑颗粒, Castbead 已掌握其配方, 工艺技术, 并加以改良变成更优质产品。</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 汽车配件、手机,、计算机电子产品, 电机制造等行业, 均离不开压铸零部件生產, 以上各工业在亚太地区 (包括中国) 发展潜力巨大, 压铸冲头固体润滑技术市场需求殷切, 对比欧美同类产品,&nbsp; Castbead 冲头润滑颗粒的质量及价格更有优势。</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 欢迎中国及亚太地区从事压铸行及业润滑油公司接触洽谈, 共同开拓市场商机。</p>',
         hk:'<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Castbead 是一家專註於潤滑化學技術的公司，其資深的技術人員擁有超過30年的潤滑產品研發應用及市場銷售經驗，涵蓋金屬加工、壓鑄潤滑，防銹清洗等領域。</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 壓鑄沖頭固體潤滑技術， 是針對鋁鎂合金冷室壓鑄機的沖頭潤滑而設，使用潤滑顆粒代替傳統石墨高粘性潤滑油能減低沖頭及料管的磨損, 延長使用壽命。優質的潤滑顆粒更能減小鋳件沙孔的產生,免除汙染,鑄件更清潔,大大降低生産成本。傳統油基柱塞潤滑油/膏在使用中產生大量有害煙氣及油霧,除了使設備及週邊骯臟,更危害操作人員健康,顆料能大大改善車間環境。</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 隨著中國壓鑄工業飛速發展, 壓鑄沖頭固體潤滑技術, 已被廣範使用; 而其核心的潤滑顆粒, Castbead 已掌握其配方, 工藝技術, 並加以改良變成更優質產品。</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 汽車配件、手機,、計算機電子產品, 電機製造等行業, 均離不開壓鑄零部件生產, 以上各工業在亞太地區 (包括中國) 發展潛力巨大, 壓鑄沖頭固體潤滑技術市場需求殷切, 對比歐美同類產品,&nbsp; Castbead 沖頭潤滑顆粒的質量及價格更有優勢。</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 歡迎中國及亞太地區從事壓鑄行及業潤滑油公司接觸洽談, 共同開拓市場商機。</p>'
      },
      chinaAddress:{
        en: "Address:G/F,  Rm115，No. 1 Ba Xiang Shang Ye Street, Wan Jiang, Dongguan City, Guangdong Province, China",
        cn: "中国:广东省东莞市万江街道坝翔商业街1 号115室",
        hk: "中國:廣東省東莞市萬江街道壩翔商業街1 號115室",
      },
      hkAddress:{
        en:'Address:Phases 3, Flat E2 , 6/F., Kwun Tong.Ctr., 448-458 Kwun Tong Rd.,Kin., Hong Kong',
        cn:'香港:香港九龙官塘工业中心三期六楼E2室',
        hk:'香港:香港九龍官塘工業中心三期六樓E2室'
      },
      newsItem: [],
      productNav: [],
      productNavNodes: [],
    };
  },
  async mounted() {
    this.$parent.currPage = 0;
    await this.$ajax.get(common.webapi.getBanner).then((res) => {
      this.$data.bannerItem = res.data.data.data;
    });
     await this.$ajax.get(common.webapi.getWebProductNodes).then((res) => {
      // debugger
      this.$data.productNavNodes = res.data.data;
    });
    await this.$ajax.get(common.webapi.getWebProductSort).then((res) => {
      this.productNav=res.data.data[0].children;
    });
    await this.$ajax.get(common.webapi.getWebTopTenNews).then(res=>{
      // debugger
      var arr=[]
      var hostu=window.location.origin
      res.data.data.data.forEach(ele => {
        arr.push({
              id: ele.id,
              displayName: ele.displayName,
              displayNameEn: ele.displayNameEn,
              remark:ele.remark,
              hrefUrl:hostu+'/#/web/corpUpdate?id='+ele.id,
              targetUrl: ele.targetUrl,
        });
      });
      this.$data.newsItem=arr
    })
    // await this.$ajax.get(common.webapi.getWebTenSolutionForIndex).then(res=>{
    //   // debugger
    //   // var arr=[]
    //   var hostu=window.location.origin
    //   res.data.result.items.forEach(ele => {
    //     this.$data.newsItem.push({
    //           id: ele.webSolution.id,
    //           displayName: ele.webSolution.displayName,
    //           displayNameEn: ele.webSolution.displayNameEn,
    //           remark:ele.webSolution.remark,
    //           hrefUrl:hostu+'/#/web/applicationField?id='+ele.webSolution.id,
    //           ossStorageObjectTargetUrl: ele.ossStorageObjectTargetUrl,
    //     });
    //   });
    //   // this.$data.newsItem=arr
    // })
  },
  methods: {
    
  },
};
</script>
<style>
.content {
  width: 100%;
}
.newsupdate {
  margin-top: 50px;
}
.products {
  margin-top: 50px;
}
.corpintro {
  /* height: 600px; */
  margin-top: 50px;
  background: #eee;
}
.corpitem {
  display: inline-flex;

  flex: 1;
}
.leftbg {
  background-image: url("../assets/castbead/intro/intro.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 80px;
}
.companylogo {
  background-color: #f5b500;
  height: 30%;
  padding: 40px;
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.slogon {
  padding: 5px 10px;
  text-align: center;
}
.introcontent {
  font-size: 16px;
  padding: 10px 30px;
  line-height: 120%;
}
.head-title {
  font-size: 26px;
  text-align: center;
  padding: 10px 20px;
}
.head-sub {
  text-align: center;
}
.head-box {
  padding: 20px;
}

.head-title {
  font-weight: 600;
  text-align: center;
}

.head-title a {
  color: #1a2f57;
  text-decoration: none;
}

.head-title a:hover {
  color: #de3114;
}

.head-sub {
  text-align: center;
}

.recent-work-description {
  background: rgba(160, 160, 160, 0.32);
}

.recent-work-item a {
  text-align: center;
}
.advantage {
  background-color: #808080;
  background-image: url(../assets/castbead/chemist.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  overflow-x: hidden;
  margin-top: 40px;
}

</style>